import { select } from 'satcheljs/lib/legacy';
import store from '../store/store';
import { isValidSection } from '../utils/isValidClause';
export default select({
    optionState: function () { return store; },
})(function isInboxRuleEditValid(state) {
    return (state.optionState.inboxRulesEditState.clauseMap.size > 0 &&
        state.optionState.inboxRulesEditState.ruleName.trim().length > 0 &&
        isValidSection('conditional') &&
        isValidSection('action') &&
        isValidSection('exception'));
});
//# sourceMappingURL=isInboxRuleEditValid.js.map